import Box, { BoxProps } from '@material-ui/core/Box';
import Checkbox, { CheckboxProps } from '@material-ui/core/Checkbox';
import clsx from 'clsx';
import React, { ReactElement, ReactNode } from 'react';
import { ReactComponent as CheckedIcon } from './CheckedIcon.svg';
import { FormControlLabelStyle, useStyles } from './index';

interface Props {
  editable?: boolean;
  disabled?: boolean;
  label: string | ReactNode;
  inline?: boolean;
  labelBold?: boolean;
  suffix?: ReactElement;
  checkboxProps?: CheckboxProps;
  wrapperProps?: BoxProps;
  isPrint?: boolean;
  isInDataGrid?: boolean;
}

const SimpleCheckbox: React.VFC<Props> = ({
  editable,
  disabled,
  label,
  inline,
  labelBold,
  suffix,
  checkboxProps,
  wrapperProps,
  isPrint,
  isInDataGrid = false,
  ...props
}) => {
  const classes = useStyles();

  return (
    <div className="no-page-break">
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          ...wrapperProps,
        }}
        style={isInDataGrid ? {} : { paddingTop: '6pt' }}
      >
        <FormControlLabelStyle
          $isPrint={isPrint}
          $isDatagrid={isInDataGrid}
          className={classes.wrapper}
          control={
            <Checkbox
              className={classes.root}
              sx={{
                '&:hover': { bgcolor: 'transparent' },
              }}
              disableRipple
              color="default"
              disabled={!editable || disabled}
              checkedIcon={
                <span
                  className={clsx(classes.icon, classes.checkedIcon)}
                  style={isPrint ? { borderColor: 'black' } : {}}
                >
                  <CheckedIcon />
                </span>
              }
              icon={<span className={classes.icon} />}
              {...checkboxProps}
            />
          }
          label={label}
        />
        <span
          style={{
            position: 'relative',
            display: 'inline-flex',
          }}
        >
          {suffix}
        </span>
      </Box>
    </div>
  );
};

export default SimpleCheckbox;
